import axiosInstance from "../../utils/axiosInstance";
import { FORM_SUBMIT_URL, BASE_URL } from "../../../constants";
import { toast } from "react-toastify";

export const validateAndSubmitUgovor = async (
  values,
  selectedRecord,
  cleanup,
  update,
  transitionToUpdate,
  setIdPredPosEvid,
  setShowPotpisivanjeConfirmationModal,
  role,
  fetchEvidencijeTableData
) => {
  const valuesCopy = { ...values };

  delete valuesCopy.dokumenti;

  const URL = FORM_SUBMIT_URL[selectedRecord];

  const formData = new FormData();

  formData.append("ugovorSJI", JSON.stringify(valuesCopy));

  if (values.dokumenti.length > 0) {
    values.dokumenti.map((attachment) =>
      formData.append("dokumenti", attachment.originFileObj)
    );
  }

  if (update) {
    const { idPredPosEvid, obrisaniDokumenti } = valuesCopy;
    formData.append("idPredPosEvid", JSON.stringify(idPredPosEvid));
    formData.append("obrisaniDokumenti", obrisaniDokumenti);
  }

  try {
    if (!update) {
      const { data } = await axiosInstance.post(`${BASE_URL}${URL}`, formData);
      const { idPredPosEvid } = data;
      if (role === "ROLE_KORISNIK") {
        setIdPredPosEvid(idPredPosEvid);
        setShowPotpisivanjeConfirmationModal(true);
      }
    } else {
      await axiosInstance.patch(`${BASE_URL}${URL}`, formData);
    }
    toast.success("Posebna evidencija spremljena", {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
    cleanup();
    fetchEvidencijeTableData();
  } catch (e) {
    if (e.response.data.statusCode == 418) {
      transitionToUpdate();
    }
    if (e.response.data.msg) {
      toast.info(e.response.data.msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } else {
      toast.info("Nešto je pošlo po krivu. Molimo pokušajte ponovno!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }
};
